import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { YOUTUBE_URL } from "@/data/content";

export default function PatternCard({ idea, testIdPrefix = "pattern-card" }) {
  const cls =
    "group flex h-full flex-col justify-between gap-10 p-8 transition-colors duration-300 hover:bg-charcoal/50 lg:p-10";
  const inner = (
    <>
      <div>
        <p className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
          <span className="inline-block h-1.5 w-1.5 rotate-45 border border-glow/60" />
          {idea.tag}
        </p>
        <h3 className="mt-5 text-balance text-xl font-medium leading-snug tracking-tight text-slate-100 transition-colors duration-300 group-hover:text-white lg:text-2xl">
          {idea.title}
        </h3>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">{idea.insight}</p>
      </div>
      <span className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 transition-colors duration-300 group-hover:text-glow">
        {idea.format}
        <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
      </span>
    </>
  );
  if (idea.href) {
    return (
      <Link to={idea.href} className={cls} data-testid={`${testIdPrefix}-${idea.slug}`}>
        {inner}
      </Link>
    );
  }
  return (
    <a
      href={YOUTUBE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cls}
      data-testid={`${testIdPrefix}-${idea.slug}`}
    >
      {inner}
    </a>
  );
}
